import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { Reservation } from '../models/Reservation'
import { RESERVATION_EXPORT_URL, RESERVATIONS_URL } from '../utils/urls'

const fetchReservations = (params: TableParams) =>
  SBAPI.FetchPaginated<Reservation[]>(RESERVATIONS_URL, params)

const fetchReservationById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Reservation>(`${RESERVATIONS_URL}/${id}`, params)

const createReservation = (reservation: Reservation) =>
  SBAPI.Post(RESERVATIONS_URL, reservation)

const updateReservation = (reservation: Reservation) =>
  SBAPI.Put(`${RESERVATIONS_URL}/${reservation.id}`, reservation)

const deleteReservation = (reservation: Reservation) =>
  SBAPI.Delete(`${RESERVATIONS_URL}/${reservation.id}`)

const triggerReservationsExport = (params: TableParams) =>
  SBAPI.Post(RESERVATION_EXPORT_URL, params)

export {
  createReservation,
  deleteReservation,
  fetchReservationById,
  fetchReservations,
  triggerReservationsExport,
  updateReservation,
}
